(function() {
  function nukeTrustpilot(root) {
    if (!root) root = document;
    // Remove widgets
    root.querySelectorAll('.trustpilot-widget').forEach(el => el.remove());
    // Remove direct links
    root.querySelectorAll('a[href*="trustpilot.com/review/peora.com"]').forEach(el => el.remove());
    // Kill the bootstrap script if something injects it
    root.querySelectorAll('script[src*="tp.widget.bootstrap"]').forEach(s => s.remove());
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => nukeTrustpilot());
  } else {
    nukeTrustpilot();
  }

  // Watch for Boost re-renders (AJAX collection/search updates)
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) nukeTrustpilot(m.target);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // If Boost fires custom events, hook them too (harmless if not present)
  window.addEventListener('boost-pfs-filter-rendered', () => nukeTrustpilot());
  window.addEventListener('boost-pfs-filter-finished', () => nukeTrustpilot());
})();
